// Rating is selected before the review's fields become visible. Load verification
// at that interaction, keeping its original auto-render and token callback.
function initializeFeedbackRecaptcha(document, window) {
    const marker = document.querySelector('script[data-kd-feedback-recaptcha]');
    const form = document.getElementById('feedbackForm');
    const button = form?.querySelector('.g-recaptcha');
    if (!marker || !form || !button) return;

    let loading = false;
    let loaded = false;
    button.disabled = true;
    function load() {
        if (loading || loaded) return;
        loading = true;
        const script = document.createElement('script');
        script.src = marker.dataset.src;
        script.async = true;
        script.onload = () => {
            window.grecaptcha.ready(() => {
                loaded = true;
                button.disabled = false;
            });
        };
        script.onerror = () => {
            loading = false;
            script.remove();
            // Keep submit disabled: never send an unverified review. A further
            // focus/change retries the load, including after a transient outage.
        };
        document.head.appendChild(script);
    }
    form.addEventListener('focusin', load);
    form.addEventListener('pointerdown', load);
    form.addEventListener('change', load);
}

if (typeof document !== 'undefined') {
    document.addEventListener('DOMContentLoaded', () => {
        if (!document.querySelector('script[data-kd-feedback-recaptcha]')) return;
        initializeFeedbackRecaptcha(document, window);
        // Initialize the rating after the deferred bundle has registered Angular.
        const $ = require('jquery');
        $('#feedbackForm .rating-container input').on('change', function () {
            const value = $(this).val();
            const scope = window.angular.element(this).scope();
            scope.$applyAsync(() => { scope.feedback.rate = value; });
            $('#feedbackForm .feedback-form-details').show();
        });
    });
}
module.exports = { initializeFeedbackRecaptcha };
